import { privateAxios } from 'services/api/privateAxios';

export const acceptOrder = id =>
  privateAxios({
    method: 'post',
    url: `/orderboard/accept/${id}`,
  });
